<template>
  <div class="blm-combine-buttons">
    <template v-for="(item, index) in buttonShow">
      <el-button
        :key="index"
        v-bind="isButton(item) ? item : {}"
        :type="isButton(item) ? item.type : 'text'"
        :disabled="isDisabled(item)"
        @click="itemClick(item)"
      >
        <el-tooltip :disabled="hasPermission(item)" :content="permissionTip" placement="top">
          <router-link v-if="isRouteLink(item)" v-bind="item">{{ item.label }}</router-link>
          <a v-else-if="isA(item)" v-bind="item">{{ item.label }}</a>
          <span v-else v-bind="item">{{ item.label }}</span>
        </el-tooltip>
      </el-button>
    </template>
    <el-dropdown v-if="buttonHide.length" class="more-action" :trigger="moreBtnConfig.trigger" @command="dropdownClick">
      <el-button v-bind="moreBtnConfig" icon-position="right">{{moreBtnConfig.label}}</el-button>
      <el-dropdown-menu slot="dropdown" class="blm-combine-buttons__dropdown">
        <el-dropdown-item v-for="(item,idx) in buttonHide" :key="idx" :data-item="item" :disabled="isDisabled(item)" >
          <el-tooltip :disabled="hasPermission(item)" :content="permissionTip" placement="right">
            <span v-bind="item">
              {{ item.label }}
              <!-- 如果是a/router-link标签类型的按钮，需要渲染隐藏的a标签，用于点击触发a标签本身的事件；a标签点击区域需和父元素的点击区域一致 -->
              <router-link v-if="isRouteLink(item)" v-bind="item">{{ item.label }}</router-link>
              <a v-if="isA(item)" v-bind="item">{{ item.label }}</a>
            </span>
          </el-tooltip>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>

export default {
  name: 'CombineButtons',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    showNum: {
      type: Number,
      default: 4,
    },
    tagName: String,
    moreBtnCfg: {
      type: Object,
      default: () => ({}),
    },
    permissionTip: {
      type: String,
      default: '暂无权限，请联系管理员开通',
    },
    query: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    }
  },
  computed: {
    isRouteLink() {
      return (item) => {
        return item.tagName && item.tagName === 'router-link' && !this.isDisabled(item)
      }
    },
    isA() {
      return (item) => {
        return item.tagName && item.tagName === 'a' && !this.isDisabled(item)
      }
    },
    isButton() {
      return (item) => {
        return item.tagName === 'el-button'
      }
    },
    hasPermission() {
      return (item) => {
        return item.permission === undefined || item.permission
      }
    },
    isDisabled() {
      return (item) => {
        return item.disabled || !this.hasPermission(item)
      }
    },
    moreBtnConfig() {
      const defaultCfg = {
        label: '',
        type: 'text',
        icon: 'BLM-icon-more',
        trigger: 'hover',
      }
      return Object.assign(defaultCfg, this.moreBtnCfg)
    },
    newList() {
      const newList = this.list.filter((item) => {
        if (!item.tagName && this.tagName) {
          item.tagName = this.tagName
        }
        if (typeof item.permission === 'function') {
          item.permission = item.permission()
        }
        if (typeof item.disabled === 'function') {
          item.disabled = item.disabled()
        }
        if (typeof item.show === 'function') {
          return item.show()
        } else {
          return item.show || (item.show === undefined)
        }
      })
      return newList
    },
    buttonShow() {
      return this.newList.slice(0, this.showNum)
    },
    buttonHide() {
      return this.newList.slice(this.showNum)
    },
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    itemClick(item) {
      if (!item) return
      if (!this.isDisabled(item)) {
        if (item.action && typeof item.action === 'function') {
          item.action(this.query)
        }
        this.$emit('actionClick', item)
      }
    },
    dropdownClick(_, e) {
      if (e && e.$attrs && e.$attrs['data-item']) {
        this.itemClick(e.$attrs['data-item'])
      }
    },
  },
}
</script>
